
.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: map.get($spacing-scale, 'md') map.get($spacing-scale, 'sm');
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: map.get($radius, 'sm') map.get($radius, 'sm') 0 0;
  cursor: pointer;
  position: relative;
  font-family: inherit;

  @include transition(border-color, color);

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-base);
    outline-offset: 2px;
  }
}

// Active state
.active {
  border-bottom-color: var(--color-text-primary);

  .label {
    color: var(--color-text-primary);
  }
}

// Inactive state
.inactive {
  .label {
    color: var(--color-text-tertiary);
  }

  &:hover {
    border-bottom-color: var(--color-grey-neutral);

    .label {
      color: var(--color-text-secondary);
    }
  }
}

// Disabled state
.disabled {
  cursor: not-allowed;
  opacity: 0.5;

  &:hover {
    border-bottom-color: transparent;
  }

  .label {
    color: var(--color-text-tertiary);
  }
}

// Tab label
.label {
  @include body-small-medium;
  white-space: nowrap;

  @include transition(color);
}

// Tab group container
.group {
  display: flex;
  align-items: center;
  gap: 0;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface-primary);
}
